<template>
	<pre v-html="$t('terms.agreement13')"></pre>
</template>

<script>
export default {
	name: 'Agreement13',
};
</script>

<style scoped></style>
